import { CrowBeeldkwaliteitScore } from './crowBeeldkwaliteitScore';

export function crowBeeldkwaliteitScoreToColorCode(crowScore?: CrowBeeldkwaliteitScore | null) {
    switch (crowScore) {
        case 'A+':
            return '#267b45';
        case 'A':
            return '#5ec54b';
        case 'B':
            return '#f4b027';
        case 'C':
            return '#fd7808';
        case 'D':
            return '#d73f2d';
        case 'NVT':
            return '#6eb3f4';
        default:
            return '#ECECEC';
    }
}
